'use client';

import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

export default function ReadingProgressCard({ readingStats }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Reading Progress</h3>
        <Icon name="BookOpenIcon" size={24} className="text-primary" />
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-inter text-muted-foreground">Current Book</span>
          <span className="text-sm font-inter font-medium text-foreground">{readingStats?.currentBook}</span>
        </div>
        
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-inter text-muted-foreground">Progress</span>
            <span className="text-sm font-inter font-medium text-foreground">{readingStats?.progressPercentage}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${readingStats?.progressPercentage}%` }}
            ></div>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-4 pt-2">
          <div className="text-center">
            <div className="text-2xl font-crimson font-semibold text-primary">{readingStats?.chaptersRead}</div>
            <div className="text-xs font-inter text-muted-foreground">Chapters Read</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-crimson font-semibold text-accent">{readingStats?.daysStreak}</div>
            <div className="text-xs font-inter text-muted-foreground">Day Streak</div>
          </div>
        </div>
      </div>
    </div>
  );
}

ReadingProgressCard.propTypes = {
  readingStats: PropTypes?.shape({
    currentBook: PropTypes?.string?.isRequired,
    progressPercentage: PropTypes?.number?.isRequired,
    chaptersRead: PropTypes?.number?.isRequired,
    daysStreak: PropTypes?.number?.isRequired
  })?.isRequired
};